import { useModuleProps } from '../../../module-props';
import { useHighestUnitCount } from '../../../selectors';
import { ProductFamilyName } from '../../../models';

import {
  appDisclaimerStyle,
  appWrapperContainer,
  highestUnitCountDisclaimerStyle
} from './app-card.styles';

export interface HighestUnitCountDisclaimerProps {
  productFamilyName: ProductFamilyName;
}

const HighestUnitCountDisclaimer = (props: HighestUnitCountDisclaimerProps) => {
  const { productFamilyName } = props;

  const { appDisclaimerLabel, usersLabel } = useModuleProps();

  const [highestUnitCount] = useHighestUnitCount(productFamilyName);

  return (
    <div css={highestUnitCountDisclaimerStyle}>
      {productFamilyName === 'Jira products' && highestUnitCount > 0 && (
        <div css={appWrapperContainer}>
          <div css={appDisclaimerStyle}>
            {appDisclaimerLabel} {highestUnitCount} {usersLabel}.
          </div>
        </div>
      )}
    </div>
  );
};

export default HighestUnitCountDisclaimer;
